module.exports = __webpack_public_path__ + "img/public_hangzhou.2e6c552c.png";